import * as Preact from "preact"

import "@fae/source/views/components/Portrait.less"

// TODO: have this return Portrait, not loose PortraitLayers
export default class Portrait {
    render() {
        let portrait = this.props.portrait
        if(portrait == undefined) return
        if(portrait instanceof Array == false) {
            portrait = [portrait]
        }
        return (
            <div class="Portrait" style={this.style}>
                {portrait.map((portraitLayer) => {
                    return (
                        <div class="PortraitLayer" animation={portraitLayer.animation} style={{
                            "z-index": 1000 - (portraitLayer.stack || 0),
                            "background-image": "url(" + (portraitLayer.image || portraitLayer) + ")",
                            "mask-image": portraitLayer.maskimage && "url(" + portraitLayer.maskimage + ")",
                            "background-color": portraitLayer.color,
                            "opacity": portraitLayer.opacity,
                            "mix-blend-mode": portraitLayer.blendmode,
                        }}/>
                    )
                })}
            </div>
        )
    }
    get style() {
        let anchor = window.anchor || this.props.anchor
        return {
            "top": anchor?.y && (anchor.y + "em"),
            "left":anchor?.x && (anchor.x + "em"),
        }
    }
}
